import { useEffect } from 'react';
import { Paper, Stack, Button, Image, Center } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { notifications } from '@mantine/notifications';
import { useAuth0 } from '../auth/useAuth';

export default function LoginPage() {
  const { loginWithRedirect, isAuthenticated, isLoading, error } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && isAuthenticated) navigate('/pipeline', { replace: true });
  }, [isAuthenticated, isLoading, navigate]);

  useEffect(() => {
    if (error) {
      notifications.show({
        title: 'Sign-in failed',
        message: error.message || 'Unable to start Auth0 login flow.',
        color: 'red',
      });
    }
  }, [error]);

  async function handleSignIn() {
    try {
      await loginWithRedirect({
        authorizationParams: {
          redirect_uri: window.location.origin,
        },
      });
    } catch (err) {
      notifications.show({
        title: 'Sign-in failed',
        message: err?.message || 'Unable to start Auth0 login flow.',
        color: 'red',
      });
    }
  }

  return (
    <Center h="100vh" style={{ background: 'var(--mantine-color-aviary-8)' }}>
      <Paper radius="xl" p={40} w={360} shadow="xl" withBorder={false}>
        <Stack align="center" gap="sm">
          <Image src="/logo.svg" w={200} h={200} fit="contain" />
          <Button
            fullWidth
            size="md"
            mt="md"
            loading={isLoading}
            onClick={handleSignIn}
          >
            Sign in
          </Button>
        </Stack>
      </Paper>
    </Center>
  );
}
